import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { Link } from 'react-router'
import { PERMISSIONS } from '@Const/permissions'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import PermissionCheck from '@Components/Utility/PermissionCheck'

const MaintenanceMobileSubLinks = observer(() => {
    const { rightsholderStore } = useContext(StoresContext)

    return (
        <div className="maintenance-mobile-sub-links">
            <PermissionCheck
                requiredPermissions={[PERMISSIONS.SUPER_USER_PERMISSIONS.manage_user_permissions]}
                orIsInternal
            >
                <Link
                    to={Navigation.rightholder.maintenance.userPermissions(rightsholderStore.currentRightsholderId)}
                    className="bold"
                >
                    User Permissions
                </Link>
            </PermissionCheck>
            <PermissionCheck
                requiredPermissions={[PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address]}
                orIsInternal
            >
                <Link
                    to={Navigation.rightholder.maintenance.memberContacts(rightsholderStore.currentRightsholderId)}
                    className="bold"
                >
                    Contact Information
                </Link>
            </PermissionCheck>
            <Link to={Navigation.rightholder.benefits(rightsholderStore.currentRightsholderId)}>Member Benefits</Link>
        </div>
    )
})

export default MaintenanceMobileSubLinks
